import BossModel from "@/models/BossModel";
import PublicImage from '@/models/PublicImage/PublicImage';

export default class Image extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/detail/image';

    /**
     *
     * @type {string}
     */
    static entity = 'productDetailImages';

    static fields() {
		return {
			id:this.number(null).nullable(),
			product_detail_id: this.number(null).nullable(),
			public_image_id: this.number(null).nullable(),
			sort_order: this.number(null).nullable(),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new Image(data[key]));
            }
            return instances;
        });
    }

    /**
     *
     * @returns {boolean|*}
     */
    PublicImage(){
        return this.getRelated('publicImage');
    }

}
